import { contentBlockSurface, index, Options } from 'shared/assets/styles';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  position: sticky;
  top: 0;
  z-index: ${index(Options.TOPBAR)};

  width: 100%;
  min-width: 0;

  ${contentBlockSurface};
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  margin-left: ${({ theme }) => `-${theme.spacing(2)}`};
`;

export const LeadingContainer = styled.div`
  flex: 1;
  min-width: 0;

  display: flex;
  align-items: center;
`;

export const Divider = styled.div`
  flex-shrink: 0;
  width: 1px;
  height: 1.6rem;
  align-self: center;
  margin-right: ${({ theme }) => theme.spacing(1)};
`;

export const NavigationContainer = styled.div`
  ${({ theme }) =>
    theme.isMobile &&
    css`
      display: none;
    `};
`;

export const InteractionsContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;

  ${({ theme }) =>
    theme.isMobile &&
    css`
      flex: initial;
    `};
`;

export const Interactions = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};

  position: relative;

  color: ${({ theme }) => theme.palette.grey[600]};
`;
